import { EmptyIcon } from "../../adapters/presenters/action-interfaces/Reports/HoldingReport";
export const enterMail = "Please Enter email.";
export const validMail = "Please Enter valid email address.";
export var ReportsEnum;
(function (ReportsEnum) {
    ReportsEnum["HOLDINGS"] = "holdings";
    ReportsEnum["POSITIONS"] = "positions";
    ReportsEnum["PNL"] = "Profit and Loss";
    ReportsEnum["TXN"] = "transactions";
    ReportsEnum["TAX"] = "tax";
    ReportsEnum["DP"] = "dp transactions";
    ReportsEnum["SUBSCRIPTION"] = "Subscription";
    ReportsEnum["ACCOUNTOVERVIEW"] = "AccountOverview";
    ReportsEnum["LEDGER"] = "ledger";
    ReportsEnum["DPC"] = "Delayed Payment Interest";
    ReportsEnum["DPBILL"] = "DPBILL";
    ReportsEnum["CONTRACTNOTES"] = "Contract notes";
    ReportsEnum["HOLDING_REVAMP"] = "holding_revamp";
})(ReportsEnum || (ReportsEnum = {}));
export const EmptyValidation = {
    [EmptyIcon.EMPTY]: {
        [ReportsEnum.HOLDINGS]: {
            icon: "edel-icon-emtpy_icon",
            message: `You don't have any ${ReportsEnum.HOLDINGS}.`,
        },
        [ReportsEnum.DP]: {
            icon: "edel-icon-reports-note",
            message: `You don't have any ${ReportsEnum.DP}.`,
        },
        [ReportsEnum.DPBILL]: {
            icon: "edel-icon-reports-note",
            message: `No results found! `,
        },
        [ReportsEnum.DPC]: {
            icon: "edel-icon-reports-note",
            message: `No results found! `,
        },
        [ReportsEnum.POSITIONS]: {
            icon: "edel-icon-emtpy_icon",
            message: `You don't have any ${ReportsEnum.POSITIONS}.`,
        },
        [ReportsEnum.PNL]: {
            icon: "edel-icon-emtpy_icon",
            message: `No records are available for the <br/> entered period, try a new period.`,
        },
        [ReportsEnum.TAX]: {
            icon: "edel-icon-emtpy_icon",
            message: `No records are available for the <br/> entered period, try a new period.`,
        },
        [ReportsEnum.TXN]: {
            icon: "edel-icon-emtpy_icon",
            message: `No records are available for the <br/> entered period, try a new period.`,
        },
        [ReportsEnum.SUBSCRIPTION]: {
            icon: "edel-icon-reports-note",
            message: `No results found! `,
        },
        [ReportsEnum.CONTRACTNOTES]: {
            icon: "edel-icon-reports-note",
            message: `No results found! `,
        },
        [ReportsEnum.ACCOUNTOVERVIEW]: {
            icon: "edel-icon-emtpy_icon",
            message: `No records are available for the <br/> entered period, try a new period.`,
        },
        [ReportsEnum.LEDGER]: {
            icon: "edel-icon-reports-note path1",
            message: `No results found! <br/>
      Try searching for something else`,
        },
        [ReportsEnum.HOLDING_REVAMP]: {
            icon: "edel-icon-no-holdings",
            message: `You don’t have any holdings<br/> Try searching for something else`,
        },
    },
    [EmptyIcon.SEARCH]: {
        icon: "edel-icon-wentwrong-search",
        message: "There are no entries matching your search criteria.",
    },
    [EmptyIcon.SEARCH_NEW]: {
        icon: "edel-icon-wentwrong-search",
        message: "Couldn’t find anything! <br/> Try searching for something else",
    },
    [EmptyIcon.FILTER]: {
        icon: EmptyIcon.FILTER,
        message: "There are no entries matching your filter criteria.",
    },
    default: "No Data available",
    [EmptyIcon.ERROR]: {
        icon: "edel-icon-emtpy_icon",
        message: "Something went wrong! Please try after sometime.",
    },
};
export const aifDesclaimer = "Face Value is considered in Price for AIF.";
export const pnlTablemessage = "Quantity in PnL report is post doing adjustment of corporate action on Ex Date. Actual impact in Demat Holding might take longer time. Hence, there might be difference in quantity as per Pnl and Holding Report.";
